<div class="relative h-full overflow-hidden max-h-[50vh] p-4">
  <mat-card class="h-full bg-[var(--main-card)] overflow-hidden">
    <custom-table
      [isLoading]="isLoading"
      [title]="'Distribution des dividendes'"
      [columns]="columns"
      [data]="dividendes"
      [enableGlobalSearch]="false"
    ></custom-table>
  </mat-card>
</div>
